// authStore.ts
import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from "zustand/middleware";
import { createJSONStorage } from 'zustand/middleware';
import { InitDataDto } from '../common/services/getInitData.service';

type InitDataState = {
  initData: InitDataDto;
  rolSelected: number | string;
  setRolSelected: (rolSelected: number | string) => void;
  facultySelected: number;
  setFacultySelected: (facultySelected: number) => void;
  setInitData: (newInitData: InitDataDto) => void;
  clearInitData: () => void;
};

const storage = createJSONStorage(() => localStorage);

export const useInitDataStore = createWithEqualityFn<InitDataState>()(
  persist(
    (set) => ({
      initData: {
        user: {
          id: '',
          name: '',
          lastName: '',
          avatarUrl: '',
          email: '',
          isActive: false,
          createdAt: '',
          updatedAt: '',
          deletedAt: null
        },
        userRoles: [],
        rolePermissions: [],
      },
      setInitData: (newInitData: InitDataDto) => set({ initData: newInitData }),
      rolSelected: '',
      facultySelected: 0,
      setRolSelected: (newRolSelected: number | string) => set({ rolSelected: newRolSelected }),
      setFacultySelected: (newFacultySelected: number) => set({ facultySelected: newFacultySelected }),
      clearInitData: () => set({
        initData: {
          user: {
            id: '',
            name: '',
            lastName: '',
            avatarUrl: '',
            email: '',
            isActive: false,
            createdAt: '',
            updatedAt: '',
            deletedAt: null
          },
          userRoles: [],
          rolePermissions: [],
        },
        rolSelected: 0,
        facultySelected: 0,
      }),
    }),
    {
      name: 'initData-storage',
      storage
    }
  )
);
